<article>
  <div class="title">Tu cuenta ha sido bloqueada</div>
  <div class="description">
    Por favor comunícate a nuestro centro de relación con inversionistas.
  </div>
  <div class="contact-info">
    <span>homebroker@gbm.com.mx</span>
    <span>INT. 01 800 426 4663</span>
    <span>CDMX. 55 5480 5846</span>
  </div>

  <div class="buttons">
    <button class="btn-movement" (click)="redirectToPatron()">Entendido</button>
  </div>
</article>
